import { Controller } from "@hotwired/stimulus"

// Phase 2.5/2.6 polish — generic Turbo Frame modal pattern shared
// across the CIP index pages (Snapshots, Scenarios, Scoring Rubrics).
// Each list page renders a single modal hosting a Turbo Frame; row /
// button clicks carry `data-turbo-frame=<frameId>` to fetch the show /
// new / edit page into the modal in place. Mirrors the established
// fund-source detail modal flow but keeps the controller surface area
// thin so any list page can adopt it with one `data-controller`.
//
// Required values:
//   data-cip-modal-frame-id-value="cip_snapshot_modal"
// Required targets:
//   detailModal — the modal wrapper (the `data-cip-modal-target` element)
export default class extends Controller {
  static targets = ["detailModal"]
  static values = { frameId: String }

  showDetailModal() {
    this._show(this.detailModalTarget)
  }

  hideDetailModal() {
    const modal = this.element.querySelector('[data-cip-modal-target="detailModal"]')
    if (!modal) return
    modal.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
    const frame = this.frameIdValue
      ? modal.querySelector(`turbo-frame#${this.frameIdValue}`)
      : modal.querySelector("turbo-frame")
    if (frame) {
      frame.innerHTML = `<div class="text-center text-sm text-gray-400 py-8">Loading…</div>`
      frame.removeAttribute("src")
      frame.removeAttribute("complete")
    }
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  _show(modal) {
    if (!modal) return
    modal.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }
}
